// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type MergeMaterialVariants_SearchQueryVariables = Types.Exact<{
  filter: Types.MaterialVariantsFilter;
  page?: Types.InputMaybe<Types.PageFilter>;
}>;


export type MergeMaterialVariants_SearchQuery = { __typename?: 'Query', materialVariants: { __typename?: 'MaterialVariantsPage', entities: Array<{ __typename?: 'MaterialVariant', id: string, code: string, displayName: string, modelNumber?: string | null | undefined, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, type: { __typename?: 'MaterialTypeDetail', code: Types.MaterialType, name: string }, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined, item: { __typename?: 'Item', id: string, name: string } }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, totalCount: number } } };

export type MergeMaterialVariants_SelectionQueryVariables = Types.Exact<{
  filter: Types.MaterialVariantsFilter;
}>;


export type MergeMaterialVariants_SelectionQuery = { __typename?: 'Query', materialVariants: { __typename?: 'MaterialVariantsPage', entities: Array<{ __typename?: 'MaterialVariant', manufacturerUrl?: string | null | undefined, id: string, code: string, displayName: string, modelNumber?: string | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string, sortOrder: number } }>, images: Array<{ __typename?: 'MaterialVariantImage', id: string, sortOrder: number, asset?: { __typename?: 'Asset', id: string, downloadUrl: string, previewUrl?: string | null | undefined } | null | undefined }>, takeoffUsages: Array<
        | { __typename?: 'ReadyPlan', id: string }
        | { __typename?: 'PlanPackage', id: string }
        | { __typename?: 'DesignPackage', id: string }
        | { __typename?: 'ProductOffering', id: string }
      >, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined, item: { __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, sortOrder: number, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }> }, type: { __typename?: 'MaterialTypeDetail', code: Types.MaterialType, name: string } }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined }> } };

export type MergeMaterialVariants_MetadataQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type MergeMaterialVariants_MetadataQuery = { __typename?: 'Query', materialBrands: Array<{ __typename?: 'MaterialBrand', id: string, name: string }>, items: Array<{ __typename?: 'Item', id: string, name: string }>, materialVariantTags: Array<{ __typename?: 'MaterialVariantTag', id: string, name: string }> };

export type MergeMaterialVariantsMutationVariables = Types.Exact<{
  input: Types.MergeMaterialVariantsInput;
}>;


export type MergeMaterialVariantsMutation = { __typename?: 'Mutation', mergeMaterialVariants: { __typename?: 'MergeMaterialVariantsResult', trackedJob: { __typename?: 'TrackedJob', id: string } } };

export type MergeMaterialVariants_PreviewDisplayNameQueryVariables = Types.Exact<{
  input: Types.PreviewMaterialVariantDisplayNameInput;
}>;


export type MergeMaterialVariants_PreviewDisplayNameQuery = { __typename?: 'Query', previewMaterialVariantDisplayName: string };

export type MergeMaterialVariants_MaterialVariantOptionFragment = { __typename?: 'MaterialVariant', id: string, code: string, displayName: string, modelNumber?: string | null | undefined, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, type: { __typename?: 'MaterialTypeDetail', code: Types.MaterialType, name: string }, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined, item: { __typename?: 'Item', id: string, name: string } }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined };

export type MergeMaterialVariants_MaterialVariantFragment = { __typename?: 'MaterialVariant', manufacturerUrl?: string | null | undefined, id: string, code: string, displayName: string, modelNumber?: string | null | undefined, materialAttributeValues: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string, dimension: { __typename?: 'MaterialAttributeDimension', id: string, name: string, sortOrder: number } }>, images: Array<{ __typename?: 'MaterialVariantImage', id: string, sortOrder: number, asset?: { __typename?: 'Asset', id: string, downloadUrl: string, previewUrl?: string | null | undefined } | null | undefined }>, takeoffUsages: Array<
    | { __typename?: 'ReadyPlan', id: string }
    | { __typename?: 'PlanPackage', id: string }
    | { __typename?: 'DesignPackage', id: string }
    | { __typename?: 'ProductOffering', id: string }
  >, listing: { __typename?: 'MaterialListing', id: string, name?: string | null | undefined, brand?: { __typename?: 'MaterialBrand', id: string, name: string } | null | undefined, item: { __typename?: 'Item', id: string, name: string, materialAttributeDimensions: Array<{ __typename?: 'MaterialAttributeDimension', id: string, name: string, sortOrder: number, values: Array<{ __typename?: 'MaterialAttributeValue', id: string, textValue: string }> }> }, type: { __typename?: 'MaterialTypeDetail', code: Types.MaterialType, name: string } }, featuredImage?: { __typename?: 'MaterialVariantImage', id: string, asset?: { __typename?: 'Asset', id: string, downloadUrl: string, previewUrl?: string | null | undefined } | null | undefined } | null | undefined };

export const MergeMaterialVariants_MaterialVariantOptionFragmentDoc = gql`
    fragment MergeMaterialVariants_MaterialVariantOption on MaterialVariant {
  id
  code
  displayName
  modelNumber
  listing {
    id
    name
    type {
      code
      name
    }
    brand {
      id
      name
    }
    item {
      id
      name
    }
  }
  featuredImage {
    id
    asset {
      id
      downloadUrl
      previewUrl(resizing: {width: 120, region: FULL})
    }
  }
}
    `;
export const MergeMaterialVariants_MaterialVariantFragmentDoc = gql`
    fragment MergeMaterialVariants_MaterialVariant on MaterialVariant {
  ...MergeMaterialVariants_MaterialVariantOption
  manufacturerUrl
  materialAttributeValues {
    id
    textValue
    dimension {
      id
      name
      sortOrder
    }
  }
  images {
    id
    sortOrder
    asset {
      id
      downloadUrl
      previewUrl(resizing: {width: 200, region: FULL})
    }
  }
  takeoffUsages {
    id
    ... on PlanPackage {
      id
    }
    ... on DesignPackage {
      id
    }
    ... on ProductOffering {
      id
    }
  }
  listing {
    id
    name
    brand {
      id
      name
    }
    item {
      id
      name
      materialAttributeDimensions {
        id
        name
        sortOrder
        values {
          id
          textValue
        }
      }
    }
  }
}
    ${MergeMaterialVariants_MaterialVariantOptionFragmentDoc}`;
export const MergeMaterialVariants_SearchDocument = gql`
    query MergeMaterialVariants_Search($filter: MaterialVariantsFilter!, $page: PageFilter) {
  materialVariants(filter: $filter, page: $page) {
    entities {
      ...MergeMaterialVariants_MaterialVariantOption
    }
    pageInfo {
      hasNextPage
      totalCount
    }
  }
}
    ${MergeMaterialVariants_MaterialVariantOptionFragmentDoc}`;

/**
 * __useMergeMaterialVariants_SearchQuery__
 *
 * To run a query within a React component, call `useMergeMaterialVariants_SearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useMergeMaterialVariants_SearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMergeMaterialVariants_SearchQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      page: // value for 'page'
 *   },
 * });
 */
export function useMergeMaterialVariants_SearchQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MergeMaterialVariants_SearchQuery, MergeMaterialVariants_SearchQueryVariables> & ({ variables: MergeMaterialVariants_SearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MergeMaterialVariants_SearchQuery, MergeMaterialVariants_SearchQueryVariables>(MergeMaterialVariants_SearchDocument, options);
      }
export function useMergeMaterialVariants_SearchLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MergeMaterialVariants_SearchQuery, MergeMaterialVariants_SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MergeMaterialVariants_SearchQuery, MergeMaterialVariants_SearchQueryVariables>(MergeMaterialVariants_SearchDocument, options);
        }
// @ts-ignore
export function useMergeMaterialVariants_SearchSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MergeMaterialVariants_SearchQuery, MergeMaterialVariants_SearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MergeMaterialVariants_SearchQuery, MergeMaterialVariants_SearchQueryVariables>;
export function useMergeMaterialVariants_SearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MergeMaterialVariants_SearchQuery, MergeMaterialVariants_SearchQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MergeMaterialVariants_SearchQuery | undefined, MergeMaterialVariants_SearchQueryVariables>;
export function useMergeMaterialVariants_SearchSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MergeMaterialVariants_SearchQuery, MergeMaterialVariants_SearchQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MergeMaterialVariants_SearchQuery, MergeMaterialVariants_SearchQueryVariables>(MergeMaterialVariants_SearchDocument, options);
        }
export type MergeMaterialVariants_SearchQueryHookResult = ReturnType<typeof useMergeMaterialVariants_SearchQuery>;
export type MergeMaterialVariants_SearchLazyQueryHookResult = ReturnType<typeof useMergeMaterialVariants_SearchLazyQuery>;
export type MergeMaterialVariants_SearchSuspenseQueryHookResult = ReturnType<typeof useMergeMaterialVariants_SearchSuspenseQuery>;
export type MergeMaterialVariants_SearchQueryResult = ApolloReactCommon.QueryResult<MergeMaterialVariants_SearchQuery, MergeMaterialVariants_SearchQueryVariables>;
export const MergeMaterialVariants_SelectionDocument = gql`
    query MergeMaterialVariants_Selection($filter: MaterialVariantsFilter!) {
  materialVariants(filter: $filter) {
    entities {
      ...MergeMaterialVariants_MaterialVariant
    }
  }
}
    ${MergeMaterialVariants_MaterialVariantFragmentDoc}`;

/**
 * __useMergeMaterialVariants_SelectionQuery__
 *
 * To run a query within a React component, call `useMergeMaterialVariants_SelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `useMergeMaterialVariants_SelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMergeMaterialVariants_SelectionQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useMergeMaterialVariants_SelectionQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MergeMaterialVariants_SelectionQuery, MergeMaterialVariants_SelectionQueryVariables> & ({ variables: MergeMaterialVariants_SelectionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MergeMaterialVariants_SelectionQuery, MergeMaterialVariants_SelectionQueryVariables>(MergeMaterialVariants_SelectionDocument, options);
      }
export function useMergeMaterialVariants_SelectionLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MergeMaterialVariants_SelectionQuery, MergeMaterialVariants_SelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MergeMaterialVariants_SelectionQuery, MergeMaterialVariants_SelectionQueryVariables>(MergeMaterialVariants_SelectionDocument, options);
        }
// @ts-ignore
export function useMergeMaterialVariants_SelectionSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MergeMaterialVariants_SelectionQuery, MergeMaterialVariants_SelectionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MergeMaterialVariants_SelectionQuery, MergeMaterialVariants_SelectionQueryVariables>;
export function useMergeMaterialVariants_SelectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MergeMaterialVariants_SelectionQuery, MergeMaterialVariants_SelectionQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MergeMaterialVariants_SelectionQuery | undefined, MergeMaterialVariants_SelectionQueryVariables>;
export function useMergeMaterialVariants_SelectionSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MergeMaterialVariants_SelectionQuery, MergeMaterialVariants_SelectionQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MergeMaterialVariants_SelectionQuery, MergeMaterialVariants_SelectionQueryVariables>(MergeMaterialVariants_SelectionDocument, options);
        }
export type MergeMaterialVariants_SelectionQueryHookResult = ReturnType<typeof useMergeMaterialVariants_SelectionQuery>;
export type MergeMaterialVariants_SelectionLazyQueryHookResult = ReturnType<typeof useMergeMaterialVariants_SelectionLazyQuery>;
export type MergeMaterialVariants_SelectionSuspenseQueryHookResult = ReturnType<typeof useMergeMaterialVariants_SelectionSuspenseQuery>;
export type MergeMaterialVariants_SelectionQueryResult = ApolloReactCommon.QueryResult<MergeMaterialVariants_SelectionQuery, MergeMaterialVariants_SelectionQueryVariables>;
export const MergeMaterialVariants_MetadataDocument = gql`
    query MergeMaterialVariants_Metadata {
  materialBrands(filter: {}) {
    id
    name
  }
  items(filter: {version: 2}) {
    id
    name
  }
  materialVariantTags {
    id
    name
  }
}
    `;

/**
 * __useMergeMaterialVariants_MetadataQuery__
 *
 * To run a query within a React component, call `useMergeMaterialVariants_MetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useMergeMaterialVariants_MetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMergeMaterialVariants_MetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useMergeMaterialVariants_MetadataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<MergeMaterialVariants_MetadataQuery, MergeMaterialVariants_MetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MergeMaterialVariants_MetadataQuery, MergeMaterialVariants_MetadataQueryVariables>(MergeMaterialVariants_MetadataDocument, options);
      }
export function useMergeMaterialVariants_MetadataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MergeMaterialVariants_MetadataQuery, MergeMaterialVariants_MetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MergeMaterialVariants_MetadataQuery, MergeMaterialVariants_MetadataQueryVariables>(MergeMaterialVariants_MetadataDocument, options);
        }
// @ts-ignore
export function useMergeMaterialVariants_MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MergeMaterialVariants_MetadataQuery, MergeMaterialVariants_MetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MergeMaterialVariants_MetadataQuery, MergeMaterialVariants_MetadataQueryVariables>;
export function useMergeMaterialVariants_MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MergeMaterialVariants_MetadataQuery, MergeMaterialVariants_MetadataQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MergeMaterialVariants_MetadataQuery | undefined, MergeMaterialVariants_MetadataQueryVariables>;
export function useMergeMaterialVariants_MetadataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MergeMaterialVariants_MetadataQuery, MergeMaterialVariants_MetadataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MergeMaterialVariants_MetadataQuery, MergeMaterialVariants_MetadataQueryVariables>(MergeMaterialVariants_MetadataDocument, options);
        }
export type MergeMaterialVariants_MetadataQueryHookResult = ReturnType<typeof useMergeMaterialVariants_MetadataQuery>;
export type MergeMaterialVariants_MetadataLazyQueryHookResult = ReturnType<typeof useMergeMaterialVariants_MetadataLazyQuery>;
export type MergeMaterialVariants_MetadataSuspenseQueryHookResult = ReturnType<typeof useMergeMaterialVariants_MetadataSuspenseQuery>;
export type MergeMaterialVariants_MetadataQueryResult = ApolloReactCommon.QueryResult<MergeMaterialVariants_MetadataQuery, MergeMaterialVariants_MetadataQueryVariables>;
export const MergeMaterialVariantsDocument = gql`
    mutation MergeMaterialVariants($input: MergeMaterialVariantsInput!) {
  mergeMaterialVariants(input: $input) {
    trackedJob {
      id
    }
  }
}
    `;

/**
 * __useMergeMaterialVariantsMutation__
 *
 * To run a mutation, you first call `useMergeMaterialVariantsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeMaterialVariantsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeMaterialVariantsMutation, { data, loading, error }] = useMergeMaterialVariantsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeMaterialVariantsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<MergeMaterialVariantsMutation, MergeMaterialVariantsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<MergeMaterialVariantsMutation, MergeMaterialVariantsMutationVariables>(MergeMaterialVariantsDocument, options);
      }
export type MergeMaterialVariantsMutationHookResult = ReturnType<typeof useMergeMaterialVariantsMutation>;
export type MergeMaterialVariantsMutationResult = ApolloReactCommon.MutationResult<MergeMaterialVariantsMutation>;
export const MergeMaterialVariants_PreviewDisplayNameDocument = gql`
    query MergeMaterialVariants_PreviewDisplayName($input: PreviewMaterialVariantDisplayNameInput!) {
  previewMaterialVariantDisplayName(input: $input)
}
    `;

/**
 * __useMergeMaterialVariants_PreviewDisplayNameQuery__
 *
 * To run a query within a React component, call `useMergeMaterialVariants_PreviewDisplayNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useMergeMaterialVariants_PreviewDisplayNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMergeMaterialVariants_PreviewDisplayNameQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeMaterialVariants_PreviewDisplayNameQuery(baseOptions: ApolloReactHooks.QueryHookOptions<MergeMaterialVariants_PreviewDisplayNameQuery, MergeMaterialVariants_PreviewDisplayNameQueryVariables> & ({ variables: MergeMaterialVariants_PreviewDisplayNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<MergeMaterialVariants_PreviewDisplayNameQuery, MergeMaterialVariants_PreviewDisplayNameQueryVariables>(MergeMaterialVariants_PreviewDisplayNameDocument, options);
      }
export function useMergeMaterialVariants_PreviewDisplayNameLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<MergeMaterialVariants_PreviewDisplayNameQuery, MergeMaterialVariants_PreviewDisplayNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<MergeMaterialVariants_PreviewDisplayNameQuery, MergeMaterialVariants_PreviewDisplayNameQueryVariables>(MergeMaterialVariants_PreviewDisplayNameDocument, options);
        }
// @ts-ignore
export function useMergeMaterialVariants_PreviewDisplayNameSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<MergeMaterialVariants_PreviewDisplayNameQuery, MergeMaterialVariants_PreviewDisplayNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MergeMaterialVariants_PreviewDisplayNameQuery, MergeMaterialVariants_PreviewDisplayNameQueryVariables>;
export function useMergeMaterialVariants_PreviewDisplayNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MergeMaterialVariants_PreviewDisplayNameQuery, MergeMaterialVariants_PreviewDisplayNameQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<MergeMaterialVariants_PreviewDisplayNameQuery | undefined, MergeMaterialVariants_PreviewDisplayNameQueryVariables>;
export function useMergeMaterialVariants_PreviewDisplayNameSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<MergeMaterialVariants_PreviewDisplayNameQuery, MergeMaterialVariants_PreviewDisplayNameQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<MergeMaterialVariants_PreviewDisplayNameQuery, MergeMaterialVariants_PreviewDisplayNameQueryVariables>(MergeMaterialVariants_PreviewDisplayNameDocument, options);
        }
export type MergeMaterialVariants_PreviewDisplayNameQueryHookResult = ReturnType<typeof useMergeMaterialVariants_PreviewDisplayNameQuery>;
export type MergeMaterialVariants_PreviewDisplayNameLazyQueryHookResult = ReturnType<typeof useMergeMaterialVariants_PreviewDisplayNameLazyQuery>;
export type MergeMaterialVariants_PreviewDisplayNameSuspenseQueryHookResult = ReturnType<typeof useMergeMaterialVariants_PreviewDisplayNameSuspenseQuery>;
export type MergeMaterialVariants_PreviewDisplayNameQueryResult = ApolloReactCommon.QueryResult<MergeMaterialVariants_PreviewDisplayNameQuery, MergeMaterialVariants_PreviewDisplayNameQueryVariables>;